import * as React from 'react';

export const Dos = () => (
  <>
    The following constitutes the agreement between Trac Technologies, Inc.
    (“Trac”) and the undersigned rights holder (“you”) regarding your use of the
    trac™ platform and distribution service (the “Service”). For good and
    valuable consideration, the sufficiency of which is hereby acknowledged, the
    parties agree as follows:
    <br />
    <br />
    <br />
    <b>1. Service Offerings</b>
    <br />
    <br />
    <br />
    Trac offers you the ability to sell customized merchandise items
    (collectively, “Merchandise”) through the Service. Your use of the Service
    for such Merchandise purposes (and any other services offered by Trac in the
    future) is governed by and subject to the terms and conditions of this
    agreement, as well as the Terms of Use and Privacy Policy located on
    www.trac.co as the same may be amended. If you elect to sell Merchandise
    through the Service, you will be responsible for selecting individual
    Merchandise items to offer, submitting and approving each Merchandise design
    embodied on your Merchandise items (each, a “Design”), and setting the
    consumer purchase price (the “Consumer Price”) for each Merchandise item
    sold through the Service. Trac provides varying levels of Design
    customization, some of which will require you to purchase a sample item to
    ensure it meets your quality standards. Regardless of Design customization,
    you are always free to purchase a sample item prior to listing your
    Merchandise for sale through the Service. Once you have created and approved
    your Design (and any samples thereof), Trac will list such Merchandise item
    for sale on your Trac profile page. You may add additional Merchandise items
    at any time. You may remove Merchandise items at your discretion.
    <br />
    <br />
    <br />
    <b>2. Grant of Rights</b>
    <br />
    <br />
    <br />
    During the term of this agreement, you hereby grant Trac the non-exclusive
    right to reproduce, distribute, perform, display, adapt, render, transmit,
    market, and promote all visual, graphic, textual, or other materials
    embodied in each Design (“Design Materials”) for purposes of distributing
    Merchandise through the Service. In addition, you hereby grant Trac the
    non-exclusive right to use and permit others to use your name, image,
    likeness, biographical information, trademarks, trade names, cover art,
    photographs, designs, and other identifying materials related to your
    Merchandise (collectively, the “Identification Materials”), as wells as
    Identification Materials concerning any collaborators, contributors,
    performers, artists, producers, and others whose contributions are embodied
    or otherwise featured on your Merchandise, in connection with the sale of
    Merchandise through the Service; provided, however, that Trac will only use
    Identification Materials supplied or approved by you. Notwithstanding the
    foregoing, the inadvertent, non-repetitive failure by Trac (or any person,
    firm, or entity deriving rights therefrom) to comply with these approval
    rights provisions will not be deemed a breach of this agreement. To the
    fullest extent allowable by law, you hereby waive any claims based on
    infringement of your so-called “moral rights” in connection with your
    Merchandise and Trac’s exploitation thereof.
    <br />
    <br />
    <br />
    <b>3. Payments</b>
    <br />
    <br />
    <br />
    (a) Trac will credit your Service account (“Wallet”) with one hundred
    percent (100%) of Trac’s actual receipts directly attributable to the
    exploitation of Your Content on all applicable Platforms during the term
    hereof, less an administration fee of three percent (3%) and any taxes,
    fees, or other charges directly related to the exploitation concerned (“Net
    Income”) in accordance with Trac’s then-current accounting and payment
    timelines applicable to similarly subscribed Trac users. Notwithstanding the
    foregoing, if you have directed Trac to make payment (“Payment Directive”)
    of any portion of your Net Income to other persons, firms, or entities
    (“Payees”), you agree that Trac may credit any such Payee’s Wallet with the
    amount indicated in your Payment Directive. All credits and payments made
    through your Payment Directive will be irreversible once withdrawn by a
    Payee, and Trac will have no liability whatsoever for any erroneous or
    unintended credits or payments made to Payees provided that such credits or
    payments were in accordance with your Payment Directive existing at the time
    the applicable credit or payment was made. All applicable Payment Directives
    will expire twelve (12) months following the date issued unless the Payee
    takes all necessary action to withdraw any Net Income previously directed by
    you. Any disputes regarding a Payment Directive will result in a temporary
    payment hold being placed on your ability to withdraw Net Income from your
    Wallet. If a Payment Directive dispute is not resolved within six (6) months
    following the date on which the financial hold was placed, the applicable
    Payment Directive will be deemed to have expired and will not be honored.
    <br />
    (b) Once payment has been credited to your Wallet, you will be able to
    withdraw all or any portion at your discretion. All withdrawals must be made
    through Trac’s then-current available payment methods. You will be solely
    responsible for any bank fees or other charges related to such withdrawals
    and any payments that may be due to any third-party rights holder in
    connection with the exploitation of Your Content, the Identification
    Materials, and otherwise in connection with your use of the Service. You are
    solely responsible for ensuring the accuracy of information related to
    withdrawals from your Wallet. Trac will have no liability whatsoever for any
    erroneous or unintended payments made by Trac based on the inaccuracy of
    payment information you have provided. Until such time as you have withdrawn
    payment, all Net Income posted to your Wallet will be pooled in an
    interest-bearing bank account with the Net Income of other Trac users. You
    agree that you will not receive interest or other earnings or benefit on the
    Net Income that Trac handles as your agent and places in such pooled
    account. In consideration for your use of the Service, you irrevocably
    transfer and assign to Trac any ownership right that you may have in any
    interest that may accrue on Net Income held in such pooled account. All
    payments made hereunder will be subject to such deductions and withholdings
    as may be required by law, and you hereby authorize Trac to make such
    deductions and withholdings as deemed required in its good faith judgment.
    <br />
    (c) Trac will provide you with electronic access to Service account
    statements detailing the calculation of Net Income and the basis for any
    credits made to your Wallet. You will not receive physical copies of any
    accounting statement, and it is your responsibility to review such
    statements once made available to you. Any objection relating to any
    accounting statement or any lawsuit arising therefrom must be made (and any
    lawsuit commenced) no later than nine (9) months after the date the
    statement is made available to you, and you hereby waive any longer statute
    of limitations that may be permitted by law. Trac has the right to rely on
    the accuracy of any third-party statements and usage reports rendered by a
    Platform, and Trac will not be liable for any errors or omissions contained
    therein.
    <br />
    (d) In the event that Trac makes any overpayment of Net Income to you, Trac
    will have the right to require you to reimburse Trac the amount of the
    overpayment; provided, however, that Trac will not be entitled to require
    you to reimburse any overpayment more than thirty (30) days after such
    overpayment was made to you, except in the case of fraud, misrepresentation,
    or gross negligence by you. Thereafter, Trac may deduct the amount of
    overpayment from any amounts otherwise payable to you under this agreement.
    To the extent that you owe any amounts to Trac as a consequence of any
    overpayment (or violation of the terms herein), Trac will have the right to
    deduct all or a portion of such amounts from any Net Income otherwise
    payable to you under this agreement (or any other agreement between you and
    Trac), and you will not have the right to terminate this agreement until
    such overpayment amount has been repaid.
    <br />
    <br />
    <br />
    <b>4. Your Obligations</b>
    <br />
    <br />
    <br />
    (a) It is your responsibility to deliver all necessary information and
    graphics files (collectively, “Graphics Files”) in the format required by
    Trac. Trac will have the right (but not the obligation) to format or
    reformat all Graphics Files to conform with any formats required by Trac or
    its manufacturing providers, as applicable. Notwithstanding the foregoing,
    you acknowledge that Trac will not be obligated to distribute your
    Merchandise through the Service until receipt of properly formatted Graphics
    Files.
    <br />
    (b)You will be solely responsible for all necessary third-party licenses and
    permissions in connection with Trac’s sale of your Merchandise hereunder, as
    well as royalties or other payments due to collaborators, contributors,
    performers, artists, producers, and others whose contributions are embodied
    or otherwise featured on your Merchandise.
    <br />
    (c) You will only access and use the Service for lawful purposes. You agree
    to abide by all applicable local, state, national, and foreign laws,
    treatises, and regulations in connection with your use of the Service,
    including applicable common law, all relevant statutes, and the rules and
    regulations of the Office of Foreign Assets Control of the U.S. Department
    of the Treasury.
    <br />
    (d) You will at all times refrain from doing any of the following while
    accessing or using the Service: (i) disable, hack, circumvent, or otherwise
    interfere with security related features of the Service or features that
    prevent or restrict use or copying of any of Trac’s content or materials;
    (ii) use any metadata, meta tags or other hidden text utilizing a Trac
    trademark, URL, or product name; (iii) upload, submit, post, email, or
    otherwise transmit any unsolicited or unauthorized advertising, promotional
    materials, junk mail, spam, chain letters, so-called pyramid schemes or any
    other form of solicitation; (iv) forge any TCP/IP packet header or any part
    of the header information in any posting or in any way use the Service to
    send altered, deceptive, or false source-identifying information; (v)
    upload, submit, post, email, or otherwise transmit through the Service any
    content or other materials that are, in the sole opinion of Trac, unlawful,
    harmful, threatening, obscene, harassing, defamatory or hateful, or that
    contain objects or symbols of hate, invade the privacy of any third party,
    contain nudity, are deceptive, threatening, abusive, inciting of unlawful
    action, defamatory, libelous, vulgar or violent or constitute hate speech,
    or are otherwise objectionable; (vi) destroy, interfere with or disrupt, or
    attempt to interfere with or disrupt, any web pages available on the
    Service, servers, or networks connected to the Service or the technical
    delivery systems of Trac’s providers or break any requirements, procedures,
    policies or regulations, of networks connected to the Service; (vii) attempt
    to scan, probe, or test the vulnerability of any Trac system or network, or
    breach, impair or circumvent any security or authentication measures
    protecting and providing security for the Service; (viii) attempt to
    decompile, disassemble, decipher or reverse engineer any of the software
    used to provide the Service; (ix) collect or store or attempt to collect or
    store personal data about other users Service without their express and
    explicit permission; (x) misrepresent or impersonate your affiliation with
    any person, firm, or entity, through pretext or some other form of social
    engineering or otherwise commit fraud; (xi) use the Service in any manner
    not permitted by the Terms of Use; or (xii) instruct, encourage, aid, or
    participate with any other individual to do any of the foregoing. Trac will
    have no obligation whatsoever to credit your Wallet with Merchandise Net
    Income or other amounts generated in violation of any of the foregoing.
    <br />
    (e) You will not disclose any non-public ideas, applications, processes,
    techniques, programs, designs, drawings, documents, diagrams, manufacturing,
    marketing, financial or personnel data, sales information, supplier,
    customer, employee, or investor information, business plans, or any other
    information not then generally known to the public concerning Trac or the
    Service (“Confidential Information”) that is furnished or made available by
    Trac or otherwise accessed by you, whether in oral, written, graphic, or
    electronic form, except to the extent that you demonstrate by competent
    written proof that the otherwise Confidential Information: (i) now or
    hereafter becomes generally known by the public through no act or failure to
    act on your part; (ii) is known to you prior to disclosure; or (iii) is
    hereafter furnished to you without disclosure limitations by a third party,
    as a matter of right (i.e., absent solicitation or circumvention in breach
    of this agreement). You agree to maintain the confidentiality of all the
    Confidential Information and will not, directly or indirectly, during the
    term hereof or at any time thereafter, transfer or disclose Confidential
    Information to any third party or take any other action with respect to the
    Confidential Information that is inconsistent with the confidential and
    proprietary nature of such information.
    <br />
    <br />
    <br />
    <b>5. Representations & Warranties</b>
    <br />
    <br />
    <br />
    You represent and warrant that: (i) you are at least eighteen (18) years of
    age and that you have the full right, power, and authority to enter into and
    to fully perform the terms of this agreement, free and clear of any and all
    claims, rights, encumbrances, and obligations whatsoever; (ii) you are not
    under any disability, restriction, or prohibition, whether contractual or
    otherwise, with respect to the right to enter into this agreement; (iii) no
    materials, ideas, or other properties furnished, owned, controlled, or
    designated by you and used in connection with your Merchandise (including
    all Design Materials and Identification Materials) will violate or infringe
    upon the rights of any person, firm, or entity including rights protected by
    contract, copyright, trademark, or rights of privacy and publicity; (iv)
    Trac will not be required to make any payment of any nature in connection
    with your Merchandise, use of the Service, or the acquisition, exercise, or
    exploitation of rights by Trac except as specifically provided in this
    agreement; (v) there will be no liens, encumbrances, or other charges
    against your Design Materials including any undisclosed collaborators; (vi)
    you recognize the inherently speculative nature of the music business and
    that Trac has made no guarantees or promises of future success or particular
    outcomes with respect to the sale of your Merchandise; and (vii) you
    acknowledge that Trac will have no obligation to exercise any of the rights
    granted to it hereunder. You agree to and do hereby indemnify, save, and
    hold Trac and its owners, agents, officers, directors, employees, attorneys,
    licensees, and assignees harmless from any and all loss or damage (including
    court costs and reasonable outside attorneys’ fees) arising out of a claim
    regarding or as a result of any inconsistency with, failure of, or breach or
    threatened breach by you of any warranty, representation, agreement,
    undertaking, or covenant contained in this agreement. Trac will give you
    prompt written notice of any claim to which the foregoing indemnity applies,
    and you may meaningfully participate in the defense of the same with counsel
    of your choosing at your sole cost and expense. Notwithstanding the
    foregoing, Trac will have the right to settle or compromise any claim to
    which your indemnity applies without your consent, provided that your
    indemnity obligations do not exceed twenty thousand dollars ($20,000).
    Further, Trac may withhold payments due to you or any Payee pending
    resolution of any such claim.
    <br />
    <br />
    <br />
    <b>6. Disclaimer of Liability</b>
    <br />
    <br />
    <br />
    In no event will Trac be liable to you for any damages whatsoever, including
    indirect, incidental, special, punitive, or consequential damages arising
    out of or in connection with your use of the Service, irrespective of
    whether the damages are foreseeable and whether or not Trac has been advised
    of the possibility of such damages. The foregoing limitation of liability
    will apply to the fullest extent permitted by law in the applicable
    jurisdiction and in no event will Trac’s aggregate liability to you exceed
    one hundred dollars ($100) except as it relates to a bona fide underpayment
    of Merchandise Net Income, in which case the maximum liability will be the
    amount of such underpayment.
    <br />
    <br />
    <br />
    <b>7. General Provisions</b>
    <br />
    <br />
    <br />
    (a) Trac reserves the sole right at any time to modify, discontinue, or
    terminate the Service or modify this agreement with notice, except that
    changes to the Terms of Use and Privacy Policy may be modified without
    notice. It is your responsibility to check the Terms of Use and Privacy
    Policy periodically for any modifications thereto. By continuing to use or
    access the Service after Trac makes and posts any such modification, you
    agree to be legally bound by the revised terms. You may not alter the terms
    of this agreement without Trac’s express written consent in each instance.
    <br />
    (b) You may terminate this agreement upon thirty (30) days’ notice. Trac may
    terminate this agreement at any time with notice to you, except that such
    termination may be without notice in the case of a violation of any
    warranty, representation, agreement, undertaking, or covenant contained in
    this agreement. Following termination of this agreement, Trac may suspend or
    block future access to your Service account in its sole discretion. In all
    instances, the termination hereof for any reason will not release either
    party from any liabilities or obligations that the parties have expressly
    agreed will survive, remain to be performed, or by their nature would be
    intended to survive any such termination, including the representations,
    warranties, indemnification obligations, and any applicable payment
    obligations.
    <br />
    (c) Trac may assign this agreement in whole or in part. You may not assign
    any rights or obligations under this agreement without Trac’s prior written
    consent in each instance.
    <br />
    (d) No breach or alleged breach by Trac of any obligations hereunder will
    entitle you to recover damages or affect any obligations hereunder, unless
    such breach (or alleged breach) has not been remedied within thirty (30)
    days following receipt of written notice from you detailing such breach (or
    alleged breach). The decision by Trac to remedy such breach (or alleged
    breach) is not, of itself, an admission of liability. If Trac receives
    notice or becomes aware of, or otherwise determines in its sole discretion,
    that a breach of this agreement has occurred or that a breach is imminent,
    then Trac may, in its sole discretion and without limiting any of its rights
    or remedies, all of which are expressly reserved: (i) cooperate with any
    third-party investigation including by disclosing your identity to third
    parties; (ii) suspend your access to or ban you from accessing the Service;
    and (iii) suspend making your Merchandise available through the Service.
    <br />
    (e) The relationship between you and Trac is solely that of an ordinary
    contract and Trac does not have any fiduciary or other special relationship
    with you. Further, nothing herein, expressed or implied, will constitute or
    contemplate a partnership, joint venture, employment, or other agency
    relationship between you and Trac; rather, you are considered an independent
    contractor for all purposes hereunder.
    <br />
    (f) This agreement is for the sole benefit of the parties hereto and their
    respective successors and permitted assignees. Nothing herein, expressed or
    implied, is intended to or confers upon any other person, firm, or entity
    any legal or equitable right, benefit, or remedy under or in connection with
    this agreement.
    <br />
    (g) Upon request, you will use commercially reasonable efforts to deliver or
    cause to be delivered to Trac such additional documents and to take or cause
    to be taken such further actions as may reasonably be necessary, proper, or
    advisable to make evidence or effectuate the rights granted by you to Trac,
    or to otherwise carry out the provisions hereof.
    <br />
    (h) All notices to be given by Trac will be sent through direct message
    through your Service account or your email address as provided in your
    Service account. Any notice to be given by you will be in writing and will
    be delivered by overnight courier or by United States certified mail,
    postage prepaid, return receipt requested to: Trac Technologies, Inc., P.O.
    Box 1511, Santa Monica, CA 90406, Attention: Legal Notice Department.
    <br />
    (i) Any controversy or claim between the parties arising out of or relating
    to this agreement, or the breach thereof, including its formation, validity,
    construction, scope, performance, breach, or cancellation (including the
    formation, validity, construction, scope, performance, breach, and or
    cancellation of this arbitration clause), will be resolved through
    confidential and binding arbitration in accordance with the JAMS Streamlined
    Arbitration Rules and Procedures with Optional Appeal under the laws of the
    state of California without regard to conflicts of laws principles.
    Notwithstanding the foregoing mandatory arbitration provisions: (i) except
    as otherwise provided herein, Trac may seek, and any state or federal court
    of competent jurisdiction is authorized to provide, interim injunctive or
    other equitable relief in aid of arbitration of any claim between the
    parties pursuant to this agreement; (ii) if you fail or refuse to
    participate in the arbitration, including the payment of your share of the
    arbitration fees, Trac has the authority (but not the obligation) to file
    suit against you as a non-participating party in any state or federal court
    located in Los Angeles, California; and (iii) if Trac is sued or joined in a
    third-party action relative to your Merchandise or your use of the Service,
    Trac will be entitled to pursue any related counterclaims, crossclaims, or
    third-party claims against you in connection with such action, and you
    hereby consent to the jurisdiction of the court and forum where the action
    is pending.
    <br />
    (j) You acknowledge that you have been represented by independent counsel or
    have had the unrestricted opportunity to consult with independent counsel of
    your own choice in connection with this agreement, and that any failure by
    you to retain independent counsel will not affect the enforceability hereof.
    <br />
    <br />
    <br />
    <b>8. Entire Agreement</b>
    <br />
    <br />
    <br />
    This document sets forth the entire understanding of the parties hereto
    relating to the subject matter hereof, and all prior or contemporaneous
    negotiations, understandings, agreements, and the like are superseded by and
    merged into the agreement reflected herein. No modification, amendment,
    waiver, or discharge of this agreement or any of the terms or provisions
    hereof will be binding unless done by a written instrument signed by the
    parties. The invalidity or unenforceability of any provision hereof will not
    affect the validity or enforceability of any other provision hereof. As used
    herein, the word “including” is nonrestrictive, and the word “or” is
    disjunctive but nonexclusive unless otherwise stated. If any legal
    proceeding brought by either party hereto to enforce or interpret this
    agreement or any of the terms contained herein, both parties will be deemed
    to have jointly drafted this agreement and neither side will enjoy the
    benefit of any evidentiary presumptions based upon the identity of the
    drafter hereof. This agreement will not be binding until signed by both
    parties and may be executed digitally and in counterparts or duplicate
    originals, each of which (including digital copies thereof) is deemed an
    original for all purposes.
    <br />
    <br />
    <br />
  </>
);

export default Dos;
